// extracted by css-extract-rspack-plugin
export default {"Text":"BypassListRow-module__Text__RZBxV","IconButton":"BypassListRow-module__IconButton__LlV5G","ActionListItemText":"BypassListRow-module__ActionListItemText__T0Tyy"};